var map = {
	"./landscape1.jpeg": 36,
	"./landscape10.jpeg": 37,
	"./landscape11.jpeg": 38,
	"./landscape2.jpeg": 39,
	"./landscape3.jpeg": 40,
	"./landscape4.jpeg": 41,
	"./landscape5.jpeg": 42,
	"./landscape6.jpeg": 43,
	"./landscape7.jpeg": 44,
	"./landscape8.jpeg": 45,
	"./landscape9.jpeg": 46,
	"./pathwokring.jpg": 47
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 35;